import { useId } from 'react';
import { COLOR_TEXT_PRIMARY_INVERSE } from '@alltrails/denali/tokens';

type InstagramIconProps = {
  className?: string;
  openInNewTab?: boolean;
  color?: string;
  noFollowSocials?: boolean;
};

export default function InstagramIcon({
  className = '',
  openInNewTab = false,
  color = COLOR_TEXT_PRIMARY_INVERSE,
  noFollowSocials
}: InstagramIconProps) {
  const titleId = useId();
  return (
    <a
      href="https://www.instagram.com/alltrails"
      target={openInNewTab ? '_blank' : '_self'}
      rel={`noreferrer${noFollowSocials ? ' nofollow' : ''}`}
      className={className}
      data-testid="instagram-icon"
    >
      <svg role="img" aria-labelledby={titleId} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <title id={titleId}>Instagram</title>
        <g fill="none" fillRule="evenodd">
          <g fill={color} fillRule="nonzero">
            <g>
              <g>
                <path
                  d="M15.5 2.794c4.139 0 4.63.015 6.265.09 4.2.191 6.162 2.185 6.353 6.354.075 1.634.09 2.125.09 6.263 0 4.14-.016 4.63-.09 6.264-.192 4.165-2.149 6.162-6.353 6.353-1.636.075-2.124.09-6.265.09-4.139 0-4.63-.015-6.263-.09-4.211-.192-6.163-2.194-6.354-6.355-.075-1.634-.09-2.123-.09-6.263 0-4.139.016-4.628.09-6.263.192-4.168 2.15-6.163 6.354-6.354 1.635-.074 2.124-.09 6.263-.09zM15.5 0c-4.21 0-4.737.018-6.39.093C3.481.351.353 3.475.094 9.109.018 10.763 0 11.29 0 15.5s.018 4.738.093 6.391c.258 5.63 3.382 8.758 9.016 9.016 1.654.075 2.181.093 6.391.093s4.738-.018 6.391-.093c5.624-.258 8.76-3.382 9.015-9.016.076-1.653.094-2.181.094-6.391s-.018-4.737-.093-6.39c-.253-5.624-3.38-8.757-9.015-9.016C20.238.018 19.71 0 15.5 0zm0 7.54c-4.396 0-7.96 3.564-7.96 7.96s3.564 7.96 7.96 7.96 7.96-3.563 7.96-7.96c0-4.396-3.564-7.96-7.96-7.96zm0 13.127c-2.853 0-5.167-2.312-5.167-5.167 0-2.853 2.314-5.167 5.167-5.167 2.853 0 5.167 2.314 5.167 5.167 0 2.855-2.314 5.167-5.167 5.167zm8.274-15.3c-1.028 0-1.86.833-1.86 1.86 0 1.027.832 1.86 1.86 1.86 1.027 0 1.86-.833 1.86-1.86 0-1.027-.833-1.86-1.86-1.86z"
                  transform="translate(-16 -590) translate(16 561) translate(0 29)"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </a>
  );
}
